export default "__VITE_ASSET__ul0SdNR1__"